import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import Button from '../../components/atoms/Button';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import OverflowingText from '../../components/foundations/OverflowingText';
import SlackIcon from '../../resources/svg/icons/slack-icon.svg';
import { TRANSLATION_KEY, WORKSPACE_STATUS } from '../constants';
import { slackAgentStatusShape } from '../propShapes';
import css from './SlackConnectControl.css';

// Ranked ahead of this member's own link: the org-wide repair is what unblocks the bot.
const connectAction = (workspace, linkedSlackUserId, onConnect, onLink) => {
    if (!workspace) return { type: 'secondary', label: 'CONNECT_WORKSPACE', onClick: onConnect };
    if (workspace.status === WORKSPACE_STATUS.REVOKED)
        return { type: 'attention', label: 'RECONNECT_WORKSPACE', tooltip: 'RECONNECT_TOOLTIP', onClick: onConnect };
    if (workspace.needs_reinstall)
        return { type: 'attention', label: 'UPDATE_WORKSPACE', tooltip: 'UPDATE_TOOLTIP', onClick: onConnect };
    if (!linkedSlackUserId)
        return { type: 'secondary', label: 'LINK_ACCOUNT', tooltip: 'LINK_TOOLTIP', onClick: onLink };
    return null;
};

const SlackConnectControl = ({ status, busy = false, onConnect, onLink, onUnlink, translate }) => {
    if (!status?.available) return null;

    const { workspace, linked_slack_user_id: linkedSlackUserId } = status;
    const action = connectAction(workspace, linkedSlackUserId, onConnect, onLink);

    if (action)
        return (
            <Button
                type={action.type}
                Icon={SlackIcon}
                showSpinner={busy}
                onClick={action.onClick}
                tooltipKey={action.tooltip && `${TRANSLATION_KEY}.${action.tooltip}`}
            >
                <Translate id={`${TRANSLATION_KEY}.${action.label}`} />
            </Button>
        );

    return (
        <div className={css.connected}>
            <SlackIcon className={css.slackIcon} />
            <OverflowingText className={css.workspaceName}>
                {workspace.team_name || workspace.team_id}
            </OverflowingText>
            <button
                type="button"
                className={css.unlink}
                disabled={busy}
                aria-label={translate(`${TRANSLATION_KEY}.UNLINK_TOOLTIP`)}
                onClick={onUnlink}
            >
                <Icon name="unlink" size={IconSizes.SMALL} interactive={false}
                    className={css.unlinkIcon} hoverText={`${TRANSLATION_KEY}.UNLINK_TOOLTIP`} />
            </button>
        </div>
    );
};

SlackConnectControl.propTypes = {
    status: slackAgentStatusShape,
    busy: PropTypes.bool,
    onConnect: PropTypes.func.isRequired,
    onLink: PropTypes.func.isRequired,
    onUnlink: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(SlackConnectControl);
